import { apiClient } from '../api/client';
import { playerAuthService } from './player-auth.service';

export interface PublishedStaffNews {
  post: { id: string; slug: string | null; title: string; bannerUrl: string | null };
  /** O banner veio, mas não deu para salvar: a notícia saiu sem ele. */
  bannerSkipped: boolean;
}

/** Permissão do cargo da loja que libera publicar notícia (no site e no Discord). */
export const NEWS_PUBLISH = 'NEWS_PUBLISH';

/** Só decide o que mostrar. Quem barra de verdade é a API, a cada envio. */
export function canPublishNews(): boolean {
  return playerAuthService.getPlayer()?.role?.permissions?.includes(NEWS_PUBLISH) ?? false;
}

export const newsService = {
  /** Publica pela vitrine. A API confere o cargo do jogador a cada envio. */
  publish(storeId: string, data: { title: string; content: string; banner?: File | null }) {
    const corpo = new FormData();
    corpo.append('title', data.title);
    corpo.append('content', data.content);
    if (data.banner) corpo.append('banner', data.banner);
    return apiClient.post<PublishedStaffNews>(`/public/stores/${storeId}/staff/news`, corpo, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
